// 新的ux系统接口，逐步替换老的uxcb
import request from './request/uxcb';
import defaultRequest from './request/default';

function buildFormData(params) {
  const formData = new FormData();

  Object.keys(params).map(key => formData.append(key, params[key]));
  return formData;
}
// 共建
export function getMotorProposal(businessNo, mobile) {
  const value = { bizType: 'getPTMsg', businessNo, mobile };
  const params = buildFormData(value);
  return request
    .post('/uxcb/interFaces/common/onlineProposal.do', params)
    .then(res => res.data);
}

export function getMotorProposalLink(params, mobile) {
  const {
    bizType,
    businessNo,
    clauseModelNo: docTemplateCode,
    comCode,
  } = params;
  const query = { bizType, businessNo, docTemplateCode, comCode, mobile };
  const search = Object.keys(query)
    .map(key => `${key}=${query[key]}`)
    .join('&');
  // return request.get(`/uxcb/interFaces/common/onlineProposal.do?${search}`);
  return `/uxcb/interFaces/common/onlineProposal.do?${search}`;
}

export function signMotorProposal(businessNo, mobile, dataURL, file) {
  const value = { dataURL, businessNo, mobile, file, bizType: 'uploadIMG' };
  const params = buildFormData(value);

  return request
    .post('/uxcb/interFaces/common/onlineProposal.do', params)
    .then(res => res.data);
}

export function signBizProposal(businessNo, mobile, dataURL, file) {
  const value = { dataURL, businessNo, mobile, file, bizType: 'nonBizTruck' };
  const params = buildFormData(value);

  return request
    .post('/uxcb/interFaces/common/onlineProposal.do', params)
    .then(res => res.data);
}

export function getMotorPayUrl(businessNo) {
  const value = { businessNo, bizType: 'getPayLink' };
  const params = buildFormData(value);
  return request
    .post('/uxcb/interFaces/common/onlineProposal.do', params)
    .then(res => res.data);
}

export function getPayLink(businessNo) {
  return defaultRequest
    .post('/uxcb/api/v1/eproposal/getPayLink', {
      businessNo,
    })
    .then(res => res.data);
}

export function getPayResult(cashierId, mobile) {
  return defaultRequest
    .post('/uxcb/api/v1/wireless/pay/payResultQuery', {
      cashierId,
      mobile,
    })
    .then(res => res.data);
}
// 非车保费条款
export function queryNoCarReadList(businessNo, mobile) {
  const params = { businessNo, mobile };
  return defaultRequest
    .get('/uxcb/api/v1/eproposal/queryNoCarReadList', { params })
    .then(res => res.data);
}
